import { useAnalyticContext } from '@application/analytic/analytic_link/mod';
import { withTranslation } from '@application/i18n/with_translation';
import { Box, Button, Flex } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { Illustration } from '@component/illustration/illustration.component';
import { Title } from '@component/title.component';
import { TopBar } from '@component/top_bar.component';
import { RouterService } from '@cortex-shim/router.service';
import { useResolve } from '@visiba/instantiation';
import { useEffect, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { AppointmentController } from '../view_appointment.controller';
import { BackgroundOutlet } from './_background_outlet';
import { UniversalConfig } from '@application/universal_config.service';

const elements = {
	illustration: styled(Illustration)`
		width: 200px;
		max-width: 100%;
	`,
};

export function ScreenDone() {
	const routerService = useResolve(RouterService);
	const analyticCtx = useAnalyticContext();
	const controller = useResolve(AppointmentController);
	const universalConfig = useResolve(UniversalConfig);

	useLayoutEffect(function whenMountTryToCloseTheWindow() {
		if (controller.appointmentInfo.peek()?.isHcp) {
			window.close();
		}
	});

	useEffect(
		function whenMount() {
			analyticCtx.service.trackPageView({
				customTitle: 'Appointment: Done',
			});
		},
		[analyticCtx],
	);

	function handleNextClick() {
		analyticCtx.trackEvent('Clicked', 'Go to case button');

		// TODO: Remove when not Angular
		const baseurl =
			(window as typeof window & { __TEMP__overrideNavigation: unknown }).__TEMP__overrideNavigation != null
				? universalConfig.alias
				: '';

		routerService.navigateByUrl(`${baseurl}/visits/video/${controller.savedTicket}`);
	}

	return (
		<BackgroundOutlet>
			<TopBar.Content onAbort={null} />
			<Flex gap={tokens.spacing.x4} grow={1}>
				<Flex
					align='center'
					gap={tokens.spacing.x2_5}
					grow={1}
					style={{
						textAlign: 'center',
					}}
				>
					<Box width='200px' height='200px'>
						<elements.illustration type='messageSent' />
					</Box>

					<Title
						title={withTranslation('View.Appointment.ScreenDone.Title')}
						titleSize='small'
						description={withTranslation('View.Appointment.ScreenDone.Description')}
					/>
				</Flex>

				{controller.appointmentInfo.peek()?.isHcp || controller.appointmentInfo.peek()?.isGuest ? null : (
					<Flex grow={1} justify='flex-end'>
						<Button variant='primary' onClick={handleNextClick}>
							{withTranslation('View.Appointment.ScreenDone.CTA')}
						</Button>
					</Flex>
				)}
			</Flex>
		</BackgroundOutlet>
	);
}
